import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sellerPortalOrderID'
})
export class SellerPortalOrderIDPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    if(value) {
      const breaks =  String(value).split('-');
      return breaks[breaks.length-1]
    } else {
      return null;
    }
  }

}
